import { createContext, useContext } from "react";

type HorizontalPositionedItemContextType = {
    updateSize: () => void;
};
export const HorizontalPositionedItemContext = createContext<HorizontalPositionedItemContextType | null>(null);

export function useHorizontalPositionedItemContext() {
    return useContext(HorizontalPositionedItemContext);
}